import { useState, useRef } from 'react'
import { Form, Button, InputGroup, Spinner } from 'react-bootstrap'

function ChatInput({ onSend, disabled }) {
  const [text, setText] = useState('')
  const [image, setImage] = useState(null)
  const [imagePreview, setImagePreview] = useState(null)
  const fileInputRef = useRef(null)

  const handleFileChange = (e) => {
    const file = e.target.files?.[0]
    if (file) {
      if (file.type.startsWith('image/')) {
        const reader = new FileReader()
        reader.onloadend = () => {
          setImage(reader.result)
          setImagePreview(reader.result)
        }
        reader.readAsDataURL(file)
      } else {
        alert('Seuls les fichiers image sont acceptés')
      }
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!text.trim() && !image) return

    onSend({
      text: text.trim(),
      image: image,
    })

    setText('')
    setImage(null)
    setImagePreview(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(e)
    }
  }

  const removeImage = () => {
    setImage(null)
    setImagePreview(null)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  return (
    <Form onSubmit={handleSubmit} className="border-top pt-3">
      {/* Image preview */}
      {imagePreview && (
        <div className="mb-2 position-relative d-inline-block">
          <img
            src={imagePreview}
            alt="Preview"
            className="rounded"
            style={{ maxHeight: '100px', maxWidth: '200px' }}
          />
          <Button
            variant="danger"
            size="sm"
            className="position-absolute top-0 end-0"
            style={{ transform: 'translate(25%, -25%)' }}
            onClick={removeImage}
          >
            ×
          </Button>
        </div>
      )}

      <InputGroup>
        {/* File upload button */}
        <Button
          variant="outline-secondary"
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled}
          title="Ajouter une image"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
            <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"/>
          </svg>
        </Button>

        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept="image/*"
          className="d-none"
        />

        {/* Text input */}
        <Form.Control
          as="textarea"
          rows={1}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Tapez votre message..."
          disabled={disabled}
          style={{ resize: 'none' }}
        />

        {/* Send button */}
        <Button
          type="submit"
          variant="primary"
          disabled={disabled || (!text.trim() && !image)}
        >
          {disabled ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"/>
            </svg>
          )}
        </Button>
      </InputGroup>

      <Form.Text className="text-muted">
        Entrée pour envoyer, Maj+Entrée pour nouvelle ligne
      </Form.Text>
    </Form>
  )
}

export default ChatInput
